import Vue from 'vue'
import axios from 'axios'
import App from './Moderator.vue'
import router from './routers/moderator'
import store from './storages/moderator'
import VueCookies from 'vue-cookies'
import YmapPlugin from 'vue-yandex-maps'
import Meta from 'vue-meta';
import VueLazyload from 'vue-lazyload';
//import interceptor from './helpers/httpInterceptor.js'

Vue.use(Meta);
import vueReactiveStorage from "vue-reactive-storage";
Vue.use(vueReactiveStorage, {
    "token": 'false',
});
import VueInputMask from '@/helpers/vue-inputmask.js';
const optionsYMap = { // you may define your apiKey, lang and version or skip this.
  apiKey: '',
  lang: 'ru_RU',
  version: '2.1'
}

axios.interceptors.response.use((response) => {
    if(+response.data.error === 403) {
        store.dispatch('rules/getTopSection');
    }
    if(response.data.version){
        if (response.data.version != process.env.VUE_APP_API_VERSION && response.data.version != store.state.notifyPageVersion){
            store.dispatch('popups/open', {name: 'isNotifyReset'});
            store.commit('setNotifyPageVersion',response.data.version);
        }
    }
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
});

Vue.use(VueInputMask);
Vue.use(VueCookies);
Vue.use(YmapPlugin, optionsYMap);
Vue.use(VueLazyload,
    {
      preLoad: 1.3,
      error: '',
      loading: '',
      attempt: 1,
      // the default is ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend']
      listenEvents: [ 'transitionend' ]
  });

Vue.config.productionTip = false

let app = new Vue({
    router,
    store,
    render: function (h) { return h(App) }
})
window.app = app;
app.$mount('#app')
router.beforeEach((to, from, next) => {
    document.getElementsByTagName('body')[0].classList.remove("no-footer");
    document.getElementsByTagName('body')[0].classList.remove("bg-white");
    if(!(localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined)){
        window.app.$store.dispatch('auth/logout');
        window.app.localStorage.token = false;
    }

    let setActions = {
        'providers': 'moderatorProviders/setBackData',
        'repayment': 'moderatorRepayment/setBackData',
        'coupons': 'moderatorCoupon/setBackData',
        'cooperation': 'moderatorCooperation/setBackData',
    };

    if (setActions[from.name] && !setActions[to.name]) {
        window.app.$store.dispatch(setActions[from.name]);
    }
    if(to.name == 'cooperation-edit'){
      document.getElementsByTagName('body')[0].classList.add("no-footer");
    }

    next()
});
